import { MatchingCriteriaPerson } from '@mark43/cad-api';

const criteriaDisplayNames: { [key in keyof MatchingCriteriaPerson]: string } = {
    driversLicenseNumber: 'DL',
    name: 'Name',
    dateOfBirth: 'DOB',
    phoneNumber: 'Phone Number',
    location: 'Location',
    involvement: 'Involvement',
};

export function getMatchingCriteriaPersonNames(matchingCriteria?: MatchingCriteriaPerson) {
    if (!matchingCriteria) {
        return '';
    }
    const names = (Object.keys(criteriaDisplayNames) as (keyof MatchingCriteriaPerson)[])
        .filter((key) => {
            const value = matchingCriteria[key];
            return value !== undefined && value !== '';
        })
        .map((key) => criteriaDisplayNames[key]);

    return names.join(', ');
}
